export const panTo = ({ map, position, }) => {
    map.panTo(position);
};
